import {
    AnnouncementCard,
    AnnouncementCardProps,
} from '@diversioteam/diversio-ds/dist/components/core/AnnouncementsCardCarousel/components/AnnouncementCard/announcementCard.types'
import { loadAnnouncements } from 'sagas/network'

import { Queries } from 'api/queries.enum'
import { featureFlagger } from '../featureFlagger'
import fixtureData from '../fixtures/announcementsCardCarousel.data.json'

import { useQuery } from './useQuery'

export const useAnnouncements = () => {
    const isHomeMocked = featureFlagger.getFeatureValue('mocked-home', false)

    const query = useQuery<AnnouncementCard[], Error>({
        queryKey: [Queries.getAnnouncements],
        queryFn: loadAnnouncements,
    })

    return !isHomeMocked
        ? query
        : {
              data: fixtureData as AnnouncementCardProps[],
              isLoading: false,
          }
}
